import { Input } from '@/components/ui/Input'
import buttonStyles from '@/styles/buttons.module.css'
import type { ChangeEvent, FormEvent, KeyboardEvent, MouseEvent } from 'react'
import styles from './forgotPassword.module.css'

type CreateNewPasswordFormValues = {
  newPassword: string
  confirmNewPassword: string
  [key: string]: string
}

// type CreateNewPasswordFormErrors = {
//   newPassword?: string
//   confirmNewPassword?: string
//   general?: string
//   [key: string]: string | undefined
// }

interface CreateNewPasswordFormProps {
  values: CreateNewPasswordFormValues
  // errors: CreateNewPasswordFormErrors
  // generalError?: string
  isLoading: boolean
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void
  handleSubmit: (e: FormEvent) => void
}

const CreateNewPasswordForm = ({ values, /* errors, */ isLoading, handleChange, handleSubmit }: CreateNewPasswordFormProps) => {
  const handleKeyDown = (event: KeyboardEvent, handler: () => void) => {
    if (event.key === 'Enter' || event.key === ' ') {
      handler()
    }
  }
  return (
    <form
      className={styles.form}
      onSubmit={(e: FormEvent) => {
        e.preventDefault()
        e.stopPropagation()
        handleSubmit(e)
      }}
    >
      <div>
        <Input
          id="newPassword"
          type="password"
          placeholder="New Password"
          value={values.newPassword}
          onChange={handleChange}
          disabled={isLoading}
          // error={errors.newPassword}
        />
      </div>

      <div>
        <Input
          id="confirmNewPassword"
          type="password"
          placeholder="Confirm New Password"
          value={values.confirmNewPassword}
          onChange={handleChange}
          disabled={isLoading}
          // error={errors.confirmNewPassword}
        />
      </div>

      <button
        type="button"
        className={buttonStyles['button-primary']}
        onClick={(e: MouseEvent) => {
          e.preventDefault()
          e.stopPropagation()
          handleSubmit(e as unknown as FormEvent)
        }}
        onKeyDown={(e) =>
          handleKeyDown(e, () => {
            e.preventDefault()
            handleSubmit(e as unknown as FormEvent)
          })
        }
        disabled={isLoading}
        style={{ opacity: isLoading ? 0.7 : 1, cursor: isLoading ? 'not-allowed' : 'pointer', padding: '16px' }}
      >
        {isLoading ? 'Submitting...' : 'Submit'}
      </button>
    </form>
  )
}

export default CreateNewPasswordForm
